
import PenAdd from "../../../assets/filled/PenAdd.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function PenAddIcon({ className, dataTestid = "PenAddIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <PenAdd data-testid={dataTestid} className={classes} {...rest} />
  );
}
